import React from "react";
import { Card, Row, Col, Badge, Button, Space, Tooltip } from "antd";
import {
  RiUser3Line,
  RiAlertLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiUserUnfollowLine,
  RiWifiLine,
  RiPauseCircleLine,
  RiPlayCircleLine,
} from "react-icons/ri";

const StatsCard = ({ stats, connectionStatus, isPaused, onTogglePause }) => {
  const getConnectionBadge = () => {
    const statusMap = {
      connected: { status: "success", text: "已連線" },
      connecting: { status: "processing", text: "連線中" },
      disconnected: { status: "error", text: "已斷線" },
    };
    const config = statusMap[connectionStatus] || statusMap.disconnected;
    return <Badge status={config.status} text={config.text} />;
  };

  return (
    <Card size="small" bordered>
      <Space direction="vertical" size={12} style={{ width: "100%" }}>
        <Row gutter={8} align="middle">
          <Col span={12}>
            {/* <Space>
              <RiWifiLine style={{ fontSize: 16, color: "#52c41a" }} />
              {getConnectionBadge()}
            </Space> */}
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Tooltip title={isPaused ? "繼續更新" : "暫停更新"}>
              <Button
                type="text"
                size="small"
                icon={isPaused ? <RiPlayCircleLine /> : <RiPauseCircleLine />}
                onClick={onTogglePause}
              >
                {isPaused ? "已暫停" : "即時"}
              </Button>
            </Tooltip>
          </Col>
        </Row>

        <Row gutter={8}>
          <Col span={12}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontWeight: "bold", color: "#1890ff", display: "flex", alignItems: "baseline", justifyContent: "center" }}>
                <RiUser3Line style={{ marginRight: 4, fontSize: 24 }} />
                <span style={{ fontSize: 24 }}>{stats.onDutyPersonnel}</span>
                <span style={{ fontSize: 16, margin: "0 2px" }}>/</span>
                <span style={{ fontSize: 16 }}>{stats.totalPersonnel}</span>
              </div>
              <div style={{ fontSize: 12, color: "#8c8c8c" }}>值班人數 / 人員總數</div>
            </div>
          </Col>
          <Col span={12}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 24, fontWeight: "bold", color: "#ff4d4f" }}>
                <RiAlertLine style={{ marginRight: 4 }} />
                {stats.activeAlerts}
              </div>
              <div style={{ fontSize: 12, color: "#8c8c8c" }}>活動警報</div>
            </div>
          </Col>
        </Row>

        <Row gutter={16} align="middle" justify="center">
          <Col span={6}>
            <div style={{ textAlign: "center" }}>
              <RiCheckboxCircleLine style={{ fontSize: 16, color: "#52c41a" }} />
              <div style={{ fontSize: 14, fontWeight: "bold" }}>{stats.onDutyOnline}</div>
              <div style={{ fontSize: 10, color: "#8c8c8c" }}>在線</div>
            </div>
          </Col>
          <Col span={6}>
            <div style={{ textAlign: "center" }}>
              <RiUserUnfollowLine style={{ fontSize: 16, color: "#8c8c8c" }} />
              <div style={{ fontSize: 14, fontWeight: "bold" }}>{stats.onDutyOffline}</div>
              <div style={{ fontSize: 10, color: "#8c8c8c" }}>離線</div>
            </div>
          </Col>
          <Col span={6}>
            <div style={{ 
              textAlign: "center",
              borderLeft: "1px solid #d9d9d9",
              paddingLeft: "8px"
            }}>
              <RiErrorWarningLine style={{ fontSize: 16, color: "#faad14" }} />
              <div style={{ fontSize: 14, fontWeight: "bold" }}>{stats.onDutyWarning}</div>
              <div style={{ fontSize: 10, color: "#8c8c8c" }}>注意</div>
            </div>
          </Col>
          <Col span={6}>
            <div style={{ textAlign: "center" }}>
              <RiAlertLine style={{ fontSize: 16, color: "#ff4d4f" }} />
              <div style={{ fontSize: 14, fontWeight: "bold" }}>{stats.onDutySos}</div>
              <div style={{ fontSize: 10, color: "#8c8c8c" }}>警急</div>
            </div>
          </Col>
        </Row>
      </Space>
    </Card>
  );
};

export default StatsCard;
